import { useLayoutEffect, useState } from "react";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const THEMES = {
  light: { baseColor: "#ebe6ef", highlightColor: "#f7f1f8" },
  dark: { baseColor: "#2c2433", highlightColor: "#3d3348" },
};

/** react-loading-skeleton theme that follows the app's `body.dark-mode` class. */
const DarkAwareSkeletonTheme = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.body.classList.contains("dark-mode")
  );

  useLayoutEffect(() => {
    const sync = () => {
      const next = document.body.classList.contains("dark-mode");
      setIsDarkMode((prev) => (prev === next ? prev : next));
    };
    sync();
    const mo = new MutationObserver(sync);
    mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
    return () => mo.disconnect();
  }, []);

  const theme = isDarkMode ? THEMES.dark : THEMES.light;
  return (
    <SkeletonTheme
      baseColor={theme.baseColor}
      highlightColor={theme.highlightColor}
    >
      {children}
    </SkeletonTheme>
  );
};

export default DarkAwareSkeletonTheme;
